import React from "react";
import ServiceSpace from "../../components/dashboard/ServiceSpace";
import pricing from "../../assets/data/pricing.json";
import { OHADA_COUNTRIES } from "../../utils/serviceFlows";

function Domiciliation() {
  return (
    <ServiceSpace
      serviceCode="domiciliation"
      flow="domiciliation"
      flowPath="/domiciliation"
      title="Domiciliation"
      lead="L'adresse professionnelle de votre entreprise chez Platform98."
      offer="Une adresse professionnelle pour votre siège social, la gestion de votre courrier et l'accès à nos espaces de travail."
      price={Math.min(
        pricing.domiciliation.mensuel,
        pricing.domiciliation.annuel,
      )}
      isEligible={(company) =>
        OHADA_COUNTRIES.includes(company.country?.toUpperCase())
      }
      unavailableText="La domiciliation est proposée aux entreprises situées dans un pays de l'espace OHADA."
    />
  );
}

export default Domiciliation;
